import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {LinkButton} from '@components/common/base/buttons'
import {noPropagate} from '@containers/hooks'
import {Header} from '../header'
import {useStore} from '../subtasks-store'
import {AddExistingOneAsParentTask} from './add-existing-one-as-parent-task'
import {parentNavigationStore} from './parent-navition-store'
import {ParentTasks} from './parent-tasks'

const BackToParent = observer(() => {
  const path = parentNavigationStore.state.path
  return path.length > 0 ? (
    <div className="relative flex items-center justify-start gap-8 mb-16">
      <LinkButton
        icon={'IconArrowLeft'}
        onClick={e => {
          e && noPropagate(e)
          parentNavigationStore.goBack()
        }}
        noPaddings
      >
        {Lang.msg.subtask.backToParent}
      </LinkButton>
    </div>
  ) : null
})

export const ParentTaskContainer = observer(() => {
  const [, store] = useStore()

  if (!store.canEdit && !store.parentTasksCount) {
    return null
  }

  return (
    <div className="mb-32">
      <Header
        title={Lang.msg.subtask.parentTasks}
        help="parentTasks"
        className="mb-16"
      />
      <BackToParent />
      <ParentTasks taskId={store.taskId} />
      {store.canEdit && (
        <div className="mt-16">
          <AddExistingOneAsParentTask />
        </div>
      )}
    </div>
  )
})
